module.exports = __webpack_public_path__ + "static/media/clock-icon.aa3777c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/bottom-home-search/clock-icon.png
// module id = 2253
// module chunks = 0